<template>
    <div class="overall-bg">
        <b-container>
            <b-row>
                <b-col>
                    <BackBtn :goback="$router.back" />
                    <Headerlayout headertext="Grn With Po"></Headerlayout>
                </b-col>
            </b-row>
        </b-container>
    </div>
    <div class="form-white-bg">
        <b-container>
            <b-row>
                <b-row>
                    <PurchaseOrder :showone="paramValue" />
                </b-row>
                <!-- <b-row>
                        <b-col lg="6" md="8" sm="6">
                            <Invoice :showone="paramValue" />
                        </b-col>
                    </b-row> -->
                <b-row>
                    <b-col lg="12">
                        <Supplier :showone="paramValue" />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="6" md="8" sm="6">
                        <GRN :showone="paramValue" />
                    </b-col>
                    <b-col lg="6" md="8" sm="6">
                        <Invoice :showone="paramValue" />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <Items :showone="paramValue" :show-fields="showFields" />
                    </b-col>
                </b-row>
                <b-row class="py-5">
                    <b-col>
                        <!-- <Table :columns="headers"></Table> -->
                        <Table :rowHover="true" filterDisplay="menu" responsiveLayout="scroll" :columns="headers"
                            :data="items">
                            <template v-slot:Add>
                                <span>
                                    <AddButton :btnname=" $t('btn.plusaddnew')"></AddButton>
                                </span>
                            </template>
                            <template v-slot:action="{ data }">
                                <span>
                                    <EditIcon />
                                    <DeleteIcon />
                                </span>
                            </template>
                        </Table>
                    </b-col>
                </b-row>
                <Footer />
            </b-row>
        </b-container>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, PropType, computed } from 'vue'
import BackBtn from '../../../../components/FormComponents/BacktoMaster.vue'
import Headerlayout from '../../../../components/Masters/HeaderLayout.vue'
import Table from '../../../../components/FormComponents/EditableTable.vue'
import Supplier from '../../../../modules/Inventory/components/Transaction/SupplierComponent.vue'
import Invoice from '../../../../modules/Inventory/components/Transaction/Invoice.vue'
import PurchaseOrder from '../../../../modules/Inventory/components/Transaction/PurchaseOrder.vue'
import GRN from '../../../../modules/Inventory/components/Transaction/stockin/grn.vue'
import Items from '../../../../modules/Inventory/components/Transaction/Item.vue'
import { useRoute } from 'vue-router';
import Footer from '../../../../components/FormComponents/Footer.vue'
export default defineComponent({
    components: {
        BackBtn,
        Headerlayout,
        Table,
        Supplier,
        Items,
        Footer,
        Invoice,
        PurchaseOrder,
        GRN
    },

    setup() {
        let showFields = {
            Category: true,
            Name: true,
            Batch: true,
            PackSize: true,
            UnitRate: true,
            Qty: true,
            MRP: true,
            Discount: true,
        };
        const dataId = ref({
            purchaseId: 0
        })
        let items = ref([]);
        const route = useRoute();

        const paramValue = computed(() => {
            return route.query.param as string;
        });
        let List = ref([])
        const headers = [
            {
                header: 'Item',
                field: ''
            },
            {
                header: 'HSN',
                field: ''
            },
            {
                header: 'Item Name',
                field: ''
            },
            {
                header: 'Purchaseing Unit',
                field: ''
            },
            {
                header: 'PO Quantity',
                field: ''
            },
            {
                header: 'Qty',
                field: ''
            },
            {
                header: 'UOM',
                field: ''
            },
            {
                header: 'Unit Rate',
                field: ''
            },
            {
                header: 'Tax',
                field: ''
            },
            {
                header: 'Discount %',
                field: ''
            },
            {
                header: 'Discount Amount',
                field: ''
            },
            {
                header: 'Tax Value',
                field: ''
            },
            {
                header: 'Sales Unit',
                field: ''
            },
            {
                header: 'Sales Tax',
                field: ''
            },
            {
                header: 'Margin',
                field: ''
            },
            {
                header: 'Sales Price',
                field: ''
            },
            {
                header: 'MRP',
                field: ''
            },

        ];


        return {
            List,
            headers,
            paramValue,
            showFields,
            items,
            dataId
        }
    }

})
</script>
